package scenes

import AppState
import com.soywiz.klock.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.ui.*
import com.soywiz.korge.view.*
import com.soywiz.korim.font.*
import com.soywiz.korim.text.*
import i18n.*
import kotlinx.coroutines.*
import utils.*

class SceneLoadingScene : Scene() {

    private lateinit var appState: AppState
    private lateinit var font: Font

    override suspend fun SContainer.sceneInit() {
        appState = injector.get()

        font = FontsLoader.loadFont(FontsLoader.GOGONO_COCOA_MOCHI_CYRILLIC)
    }

    override suspend fun SContainer.sceneMain() {
        val sceneClass = appState.sceneToLoad ?: LobbyScene::class

        val baseLoadingText = Localization.strings.scene.loading.loading
        val loadingText = uiText(baseLoadingText, 150.0, 100.0)
            .position(32.0, GameDimensions.V_HEIGHT - 100.0)
            .apply {
                textAlignment = TextAlignment.MIDDLE_LEFT
                textSize = 32.0
                textFont = font
            }

        val text = uiText(
            text = "${Localization.strings.scene.loading.level} ${appState.nextLevel}",
            width = 150.0,
            height = 100.0
        )
            .position(GameDimensions.V_WIDTH / 2.0 - 75.0, GameDimensions.V_HEIGHT / 2.0 - 50.0)
            .apply {
                textAlignment = TextAlignment.MIDDLE_CENTER
                textSize = 32.0
                textFont = font
            }

        val fps = 60

        var timer = 0
        var accumulator = 0
        var anim = 0
        val startLoading = fps / 1
        var loadJob: Deferred<Scene>? = null
        addFixedUpdater(fps.timesPerSecond) {
            timer++
            accumulator++

            if (accumulator >= 20) {
                anim++
                accumulator = 0

                if (anim > 3) {
                    anim = 0
                    loadingText.text = baseLoadingText
                } else {
                    var resultText = baseLoadingText
                    for (i in 0 until anim) {
                        resultText += "."
                    }
                    loadingText.text = resultText
                }
            }

            if (loadJob == null && timer >= startLoading) {
                loadJob = sceneContainer.changeToAsync(sceneClass)
            }
        }
    }
}
